<template>
    <nav class="stepnav">
        <a class="" href="/cart" v-if="utm_medium!='email'" >{{$t('shopping.cart')}}</a>
        <a :class="{'step':step=='contact_information'}" :href="contact_information">{{$t('shopping.infomation')}}</a>
        <a :class="{'step':step=='shipping_method','test':shipping_method=='javascript:;'}" :href="shipping_method" >{{$t('shopping.shipping')}}</a>
        <a :class="{'step':step=='payment_method','test':payment_method=='javascript:;'}" :href="payment_method">{{$t('shopping.payment')}}</a>
    </nav>
</template>
<script>
    export default {
        props: ["step", "cart","checkout_address_2_config","checkout_phone_config"],
        data() {
            return {
                cart_hash:null,
                utm_medium:null,
                contact_information: this.replaceSearch('step','contact_information'),
                shipping_method: this.replaceSearch('step','shipping_method'),
                payment_method: this.replaceSearch('step','payment_method'),
            }
        },
       beforeMount(){
          this.cart_hash= this.getCookie('cart_hash');
          this.utm_medium=this.getSearch('utm_medium');
        },
        mounted() {
            this[this.step]='javascript:;';
             if (this.cart.address.first_name == ""||(this.checkout_address_2_config=="required"&&this.cart.address.address_2 == "")||(this.checkout_phone_config=="required"&&this.cart.address.phone == "")) {
                this.shipping_method = 'javascript:;'
                this.payment_method = 'javascript:;'
            } else if (!this.cart.shipping.chosen_method) {
                this.payment_method = 'javascript:;'
            }
        }
    };
</script>
<style scoped lang='scss'>
    .stepnav {
        margin-bottom: 12px;
        text-align: center;
        a {
            color: #128FAE;
            font-size: 12px;
            text-decoration: none;
        }

        &>a:not(:last-child)::after {
            content: ">";
            margin: 0 5px;
        }
        .step {
            font-weight: 500 ;
            color: #333333 !important;
            cursor: text;
        }
        .test{
            color: #737373;
            cursor: text;
        }
    }
</style>